import { Component, Fragment, Host, h, type JSX, Prop } from '@stencil/core';
import type { BreadcrumbItem } from '../../helpers/utils/breadcrumb-types';

@Component({
  tag: 'cms-breadcrumb',
  styleUrl: 'cms-breadcrumb.scss',
  shadow: true,
})
export class CmsBreadcrumb {
  private data: Array<BreadcrumbItem> = [];

  /**
   * set the items
   */
  @Prop() items: BreadcrumbItem[] | string;

  /**
   * set the accessibility label
   */
  @Prop() label = 'breadcrumb';

  componentWillLoad() {
    if (this.items) {
      this.data =
        typeof this.items === 'string' ? JSON.parse(this.items) : this.items;
    }
  }

  private renderBreadcrumbItem(
    item: BreadcrumbItem,
    index: number,
    last: boolean,
  ): JSX.Element {
    const url = index === 0 ? '/' : item.url;
    return (
      <li class='item'>
        {last ? (
          <span class='text'>{item.label}</span>
        ) : (
          <Fragment>
            <cms-link
              href={url}
              type='standalone'
              linkTitle={item.label}
              content={item.label}
              size='sm'
              spacing='none'
              class='text'
            />
            <cms-icon alt='' size='sm' icon='arrowRight' />
          </Fragment>
        )}
      </li>
    );
  }

  render() {
    return (
      <Host>
        <section class='container'>
          <nav class='inner' aria-label={this.label}>
            <ol class='list'>
              {this.data.map((item, index) =>
                this.renderBreadcrumbItem(
                  item,
                  index,
                  index === this.data.length - 1,
                ),
              )}
            </ol>
          </nav>
        </section>
      </Host>
    );
  }
}
